/**
 * 智能会议室 API（独立模块，避免列表页拉取整份 api.js 时的额外解析开销）
 */
import axios from 'axios';
import { BaseApiUrl } from './base';

export { BaseApiUrl };

const base = BaseApiUrl;

const deptTreeCache = new Map();
const deptTreeTtlMs = 5 * 60 * 1000;
const campusListRequests = new Map();

function deptTreeCacheKey(params) {
  return JSON.stringify(params || {});
}

/** 部门树（带短时缓存，供会议室权限等使用） */
export const getDepartmentTree = (params) => {
  const key = deptTreeCacheKey(params);
  const cached = deptTreeCache.get(key);
  if (cached && Date.now() < cached.expireAt) {
    return Promise.resolve(cached.data);
  }
  return axios.get(`${base}/api/department/getDepartmentTree`, { params }).then((res) => {
    deptTreeCache.set(key, { data: res, expireAt: Date.now() + deptTreeTtlMs });
    return res;
  });
};

/** 校区列表；合并同一学校同时发起的请求，避免页面初始化重复查询。 */
export const getCampusList = (params) => {
  const key = JSON.stringify(params || {});
  const pending = campusListRequests.get(key);
  if (pending) return pending;

  const request = axios.get(`${base}/api/Campus/GetList`, { params }).then(
    (res) => {
      campusListRequests.delete(key);
      return res;
    },
    (error) => {
      campusListRequests.delete(key);
      throw error;
    }
  );
  campusListRequests.set(key, request);
  return request;
};

export const getCplateTerminalListPage = (params) =>
  axios.get(`${base}/api/CplateTerminal/get`, { params });

export const getMeetingRoomListPage = (params) =>
  axios.get(`${base}/api/MeetingRoom/GetList`, { params });

export const getMeetingRoomDetail = (id) =>
  axios.get(`${base}/api/MeetingRoom/GetDetail`, { params: { id } });

export const addMeetingRoom = (params) =>
  axios.post(`${base}/api/MeetingRoom/Post`, params);

export const editMeetingRoom = (params) =>
  axios.put(`${base}/api/MeetingRoom/Put`, params);

export const deleteMeetingRoom = (id) =>
  axios.delete(`${base}/api/MeetingRoom/Delete`, { params: { id } });

export const getMeetingRoomQr = (roomId) =>
  axios.get(`${base}/api/MeetingRoom/GetRoomQr`, { params: { roomId } });

export const getMeetingRoomBoundCplates = (roomId) =>
  axios.get(`${base}/api/MeetingRoom/GetBoundCplateTerminals`, { params: { roomId } });

export const getMeetingBookingListPage = (params) =>
  axios.get(`${base}/api/MeetingBooking/GetList`, { params });

export const getMeetingBookingDetail = (id) =>
  axios.get(`${base}/api/MeetingBooking/GetDetail`, { params: { id } });

export const cancelMeetingBooking = (bookingId) =>
  axios.post(`${base}/api/MeetingBooking/Cancel`, null, { params: { bookingId } });

export const approveMeetingBooking = (params) =>
  axios.post(`${base}/api/MeetingBooking/Approve`, params);

export const rejectMeetingBooking = (params) =>
  axios.post(`${base}/api/MeetingBooking/Reject`, params);

export const getMeetingBookingPendingParticipation = (params) =>
  axios.get(`${base}/api/MeetingBooking/PendingParticipation`, { params });

export const getMeetingBookingQr = (bookingId) =>
  axios.get(`${base}/api/MeetingBooking/GetBookingQr`, { params: { bookingId } });

export const exportMeetingBooking = (params) =>
  axios.get(`${base}/api/MeetingBooking/Export`, { params, responseType: 'blob' });

export const cancelMeetingRecurringBooking = (recurringId) =>
  axios.post(`${base}/api/MeetingBooking/CancelRecurring`, null, { params: { recurringId } });

export const checkInMeetingBooking = (params) =>
  axios.post(`${base}/api/MeetingBooking/CheckIn`, params);

/** 按部门全量拉取教职工（与报修审批流 GetTeacherMasterList 一致） */
export const getTeacherMasterList = (params) =>
  axios.get(`${base}/api/TeacherMaster/GetTeacherMasterList`, { params });

/** 按父部门获取任教教师（自动含子部门） */
export const getTeachingTeachersByDepartments = (params) =>
  axios.get(`${base}/api/TeacherMaster/GetTeachingTeachersByDepartments`, { params });

export const searchMeetingBookingParticipants = (params) =>
  axios.get(`${base}/api/MeetingBooking/SearchParticipants`, { params });

/** 按班级 ID 获取学生下拉（仅该班学生，避免全校检索） */
export const getStudentSelectListByClassId = (departmentId) =>
  axios.get(`${base}/api/StudentInfo/GetStudentSelectListByClassId`, { params: { departmentId } });
